import { StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { iconFamily, iconSize, iconGlyphs } = theme();
    const styles = StyleSheet.create({
        icon: {
            fontFamily: iconFamily,
            fontSize: iconSize,
            fontStyle: "normal",
            fontWeight: "normal",
            height: iconSize,
            lineHeight: iconSize,
            minHeight: iconSize,
            minWidth: iconSize,
            width: iconSize,
        },
    });
    return {
        ...styles,
        iconGlyphs,
    };
};
export { style };
